export const elms = {
  ham: document.querySelector('.c-ham'),
  header: document.querySelector('.l-header'),
  guidelines: document.querySelector('.p-top-guidelines'),
  ipLeadSlider: document.querySelector('.p-ip-lead-slider__swiper'),
  results: document.querySelector('.p-projects'),
};
